import { useContext } from 'react';
import { QueryFunctionContext, useQuery } from 'react-query';
import { parseUserKey, userKeys } from '../../cache-keys/userKeys';
import { assignment_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { queryFunction } from '../../query-function';

function assignedApplicationsParams({
  queryKey,
}: QueryFunctionContext<
  ReturnType<(typeof userKeys)['assignedApplications']>
>) {
  const { user, country } = parseUserKey(queryKey);
  return {
    Country: country,
    User: user,
    Processed: false,
  };
}

export function useAssignedApplications(
  country: string,
  options?: { enabled?: boolean },
) {
  const {
    state: {
      user: { token, clientID },
    },
  } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = userKeys.assignedApplications({
    user: clientID,
    country,
  });
  return useQuery(
    cacheKey,
    queryFunction(assignment_api.find(api), assignedApplicationsParams),
    {
      enabled: token.length > 0 && (options?.enabled ?? true),
    },
  );
}
